// extracted by mini-css-extract-plugin
export default {"container":"SummarySection_container__-kboK","panel":"SummarySection_panel__PGhxi","schedulePanel":"SummarySection_schedulePanel__j+iY4"};